/**
 * Helper class to construct the URL for GitHubs web authentication flow
 * {@link https://docs.github.com/en/enterprise-server@3.0/developers/apps/building-oauth-apps/authorizing-oauth-apps}
 */
export class GithubAuthRequest {
  private redirectUri?: string;
  private state?: string;

  constructor(
    private hostName: string,
    private clientId: string,
  ) {}

  public getAuthFlowUrl(): string {
    return `https://${this.hostName}/login/oauth/authorize`
      .concat('?')
      .concat(`client_id=${this.clientId}`)
      .concat(this.state ? `&state=${this.state}` : '')
      .concat(this.redirectUri ? `&redirect_uri=${this.redirectUri}` : '');
  }

  public set redirectUriParameter(redirectUri: string) {
    this.redirectUri = encodeURIComponent(redirectUri);
  }

  public set stateParameter(state: string) {
    this.state = encodeURIComponent(state);
  }
}
